;var TzClock = (function(){
    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function TzClock(server_time, transitions) {
        var has_transitions = transitions['has_transitions'];
        var raw_offset = parseInt(transitions['raw_offset'], 10) * 1000;
        var dst_offset = parseInt(transitions['dst_offset'], 10) * 1000;
        var dst_starts = parseInt(transitions['dst_starts'], 10) * 1000;
        var dst_ends = parseInt(transitions['dst_ends'], 10) * 1000;

        var self = this;
        this._server_time = Math.round(parseFloat(server_time) * 1000);
        this._renderers = [];
        this._c_ts = null;
        this._c_ts_base = null;

        var timeout;
        var started_from;

        function tick() {
            self._c_ts_base = Date.now() - started_from + self._server_time;
            if (has_transitions) {
                if (dst_starts && dst_ends) {
                    if (dst_starts < dst_ends) {
                        if (dst_starts <= self._c_ts_base && self._c_ts_base < dst_ends) {
                            self._c_ts = self._c_ts_base + dst_offset;
                        } else {
                            self._c_ts = self._c_ts_base + raw_offset;
                        }
                    } else {
                        if (self._c_ts_base < dst_ends || self._c_ts_base >= dst_starts) {
                            self._c_ts = self._c_ts_base + dst_offset;
                        } else {
                            self._c_ts = self._c_ts_base + raw_offset;
                        }
                    }
                }
            } else {
                self._c_ts = self._c_ts_base + raw_offset;
            }

            for (var c_idx in self._renderers) {
                self._renderers[c_idx]['render'].call(self._renderers[c_idx], self._c_ts, self._c_ts_base);
            }

            timeout = setTimeout(tick, (self._c_ts_base % 1000 === 0 ? 1000 : Math.abs(Math.ceil(self._c_ts_base / 1000) * 1000 - self._c_ts_base)));
        }

        function start() {
            started_from = Date.now();
            timeout = setTimeout(tick, 1000);
        }

        TzClock.prototype.registerClockRenderer = function (clock_renderer) {
            this._renderers.push(clock_renderer);
        };
        TzClock.prototype.getClockRenderers = function () {
            return this._renderers;
        };
        TzClock.prototype.getTsTimezone = function () {
            return this._c_ts;
        };
        TzClock.prototype.getTsUTC = function () {
            return this._c_ts_base;
        };
        TzClock.prototype.start = start;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
    }

    var locales = {};
    var defaultLocaleWeekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function localeWeekdays(dnum) {
        return this._weekdays[dnum];
    }

    var defaultLocaleMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    function localeMonths(mnum) {
        return this._months[mnum];
    }

    Locale.prototype.set = set;
    Locale.prototype.months = localeMonths;
    Locale.prototype.weekdays = localeWeekdays;

    var baseConfig = {
        weekdays: defaultLocaleWeekdays,
        months: defaultLocaleMonths
    };

    TzClock.defineLocale = function(name, config) {
        if (config !== null) {
            locales[name] = new Locale(config);
        } else {
            delete locales[name];
            return null;
        }
    };

    TzClock.getLocale = function (name) {
        if(name in locales) {
            return locales[name];
        } else {
            return new Locale(baseConfig);
        }
    };
    return TzClock;
})();

(function(obj){
    'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function addLeadingZero(val) {
        var s = val < 0 ? "-" : "";
        val = Math.abs(val);

        return s + (val < 10 ? "0" + val : val);
    }

    function defineMeridiem(hours) {
        return hours > 11 ? "PM" : "AM";
    }

    function hoursMeridiem(hours) {
        if (hours > 11) {
            hours -= 12;
        }
        if(hours == 0) {
            hours = 12;
        }
        return hours;
    }

    var tU = "undefined";

    function renderClock(ts) {
        var c_do = new Date(ts);
        this._renderTo.innerHTML = this._template.replace('%Y', String(c_do.getUTCFullYear()))
            .replace('%mon', this._locale.months(c_do.getUTCMonth()))
            .replace('%lday', this._locale.weekdays(c_do.getUTCDay()))
            .replace('%mday', String(c_do.getUTCDate()))
            .replace('%Mday', addLeadingZero(c_do.getUTCDate()))
            .replace('%H', addLeadingZero(c_do.getUTCHours()))
            .replace('%h', hoursMeridiem(c_do.getUTCHours()))
            .replace('%i', addLeadingZero(c_do.getUTCMinutes()))
            .replace('%s', addLeadingZero(c_do.getUTCSeconds()))
            .replace('%ampm', defineMeridiem(c_do.getUTCHours()));
    }

    function compileTemplateDigital() {
        var t_time12sec = "%h:%i:%s %ampm",
            t_time24sec = "%H:%i:%s",
            t_time12no_sec = "%h:%i %ampm",
            t_time24no_sec = "%H:%i",
            t_date = "%lday %Mday, %mon %Y";

        if(this._config['showseconds']) {
            if(this._config['hourtype'] == 12) {
                this._template = t_time12sec;
            } else {
                this._template = t_time24sec;
            }
        } else {
            if(this._config['hourtype'] == 12) {
                this._template = t_time12no_sec;
            } else {
                this._template = t_time24no_sec;
            }
        }
        if(this._config['showdate']) {
            this._template += ', ' + t_date;
        }
    }

    function compileTemplateBanner() {
        var F12_time = "<span>%h</span>" +
            "<span>%i</span>" +
            "<span>%s</span>" +
            "<sup>%ampm</sup>";

        var F24_time = "<span>%H</span>" +
            "<span>%i</span>" +
            "<span>%s</span>";

        var DATE_template = "%lday, %mon %mday, %Y";

        if(this._config['hourtype'] == 12) {
            this._template = F12_time;
        } else {
            this._template = F24_time;
        }
        this._template = "<div class=\"time\">" + this._template + "</div>";
        if(this._config['showdate']) {
            this._template  += "<p>" + DATE_template + "</p>";
        }
    }

    function DigitalClock(node, options) {
        this._renderTo = node;
        this._template = '';
        this._config = {'showdate': 1, 'showseconds' : 1, 'hourtype' : 12, 'locale': 'en'};
        var self = this;

        options = options || {};
        if(typeof options['hourtype'] !== tU) {
            this._config['hourtype'] = options['hourtype'];
        }
        if(typeof options['showseconds'] !== tU) {
            this._config['showseconds'] = parseInt(options['showseconds'], 10);
        }
        if(typeof options['showdate'] !== tU) {
            this._config['showdate'] = parseInt(options['showdate'], 10);
        }
        if(typeof options['locale'] !== tU) {
            this._config['locale'] = options['locale'];
        }
        this._locale = TzClock.getLocale(this._config['locale']);

        this.compileTemplate();
    }
    DigitalClock.prototype.compileTemplate = compileTemplateDigital;
    DigitalClock.prototype.render = renderClock;
    DigitalClock.prototype.updateConfig = function (prop, val) {
        this._config[prop] = val;
        this.compileTemplate();
    };

    function TimeBanner(node, options) {
        DigitalClock.call(this, node, options);
    }
    TimeBanner.prototype = Object.create(DigitalClock.prototype);
    TimeBanner.prototype.constructor = TimeBanner;
    TimeBanner.prototype.compileTemplate = compileTemplateBanner;

    function renderConverterClock(ts, ts_base) {
        var c_do = new Date(ts);

        var t_time12sec = "%h:%i:%s",
            t_time24sec = "%H:%i:%s",
            t_time12no_sec = "%h:%i",
            t_time24no_sec = "%H:%i",
            t_date = "%lday, %mon %mday, %Y",
            t_time;

        var date_str = t_date.replace('%Y', String(c_do.getUTCFullYear()))
            .replace('%mon', this._locale.months(c_do.getUTCMonth()))
            .replace('%lday', this._locale.weekdays(c_do.getUTCDay()))
            .replace('%mday', String(c_do.getUTCDate()));

        if(this._config['showseconds']) {
            if(this._config['hourtype'] == 12) {
                t_time = t_time12sec;
            } else {
                t_time = t_time24sec;
            }
        } else {
            if(this._config['hourtype'] == 12) {
                t_time = t_time12no_sec;
            } else {
                t_time = t_time24no_sec;
            }
        }

        var time_str = t_time.replace('%H', addLeadingZero(c_do.getUTCHours()))
            .replace('%h', hoursMeridiem(c_do.getUTCHours()))
            .replace('%i', addLeadingZero(c_do.getUTCMinutes()))
            .replace('%s', addLeadingZero(c_do.getUTCSeconds()));

        const clockElement = document.getElementById(`${this._starts_with}_time_${this._idx}`);
        const meridiemElement = document.getElementById(`${this._starts_with}_mid_${this._idx}`);

        clockElement.innerHTML = time_str;

        if(this._config['hourtype'] == 12) {
            meridiemElement.style.display = "inline-block";
            meridiemElement.innerHTML = defineMeridiem(c_do.getUTCHours());
        } else {
            meridiemElement.style.display = "none";
            meridiemElement.innerHTML = defineMeridiem(c_do.getUTCHours());
        }

        const dateElement = document.getElementById(`${this._starts_with}_weekday_${this._idx}`);
        dateElement.innerHTML = date_str;
        if(isFunction(this._callback)) { this._callback(ts, ts_base); }
    }

    function ConverterClock(starts_with, idx, config, onRender) {
        this._starts_with = starts_with;
        this._idx = idx;
        this._config = config;
        this._callback  = onRender;

        this._locale = TzClock.getLocale(this._config['locale']);
    }
    ConverterClock.prototype.render = renderConverterClock;
    ConverterClock.prototype.updateConfig = function (prop, val) {
        this._config[prop] = val;
    };

    function TimeBannerMain(time_el, date_el, options){
        this._renderToTime = time_el;
        this._renderToDate = date_el;
        this._templateTime = '';
        this._templateDate = '';

        this._config = {'showseconds' : 1, 'hourtype' : 12, 'locale': 'en'};

        options = options || {};
        if(typeof options['hourtype'] !== tU) {
            this._config['hourtype'] = options['hourtype'];
        }
        if(typeof options['showseconds'] !== tU) {
            this._config['showseconds'] = parseInt(options['showseconds'], 10);
        }
        if(typeof options['locale'] !== tU) {
            this._config['locale'] = options['locale'];
        }
        this._locale = TzClock.getLocale(this._config['locale']);

        this.compileTemplate();
    }

    function compileMainBannerTemplates() {
        var F12_time = "<span>%h</span>" +
            "<span>%i</span>" +
            "<span>%s</span>" +
            "<sup>%ampm</sup>";

        var F24_time = "<span>%H</span>" +
            "<span>%i</span>" +
            "<span>%s</span>";

        this._templateDate = "%lday, %mon %mday";
        this._templateDate = "<span class=\"city-day\">" + this._templateDate + "</span>";

        if(parseInt(this._config['hourtype'], 10) === 12) {
            this._templateTime = F12_time;
        } else {
            this._templateTime = F24_time;
        }
        this._templateTime = "<div class=\"time\">" + this._templateTime + "</div>";
    }

    function renderTimeBannerMain(ts) {
        var c_do = new Date(ts);
        this._renderToTime.innerHTML = this._templateTime.replace('%H', addLeadingZero(c_do.getUTCHours()))
            .replace('%h', hoursMeridiem(c_do.getUTCHours()))
            .replace('%i', addLeadingZero(c_do.getUTCMinutes()))
            .replace('%s', addLeadingZero(c_do.getUTCSeconds()))
            .replace('%ampm', defineMeridiem(c_do.getUTCHours()));

        this._renderToDate.innerHTML = this._templateDate.replace('%Y', String(c_do.getUTCFullYear()))
            .replace('%mon', this._locale.months(c_do.getUTCMonth()))
            .replace('%lday', this._locale.weekdays(c_do.getUTCDay()))
            .replace('%mday', String(c_do.getUTCDate()))
            .replace('%Mday', addLeadingZero(c_do.getUTCDate()))
    }

    TimeBannerMain.prototype.compileTemplate = compileMainBannerTemplates;
    TimeBannerMain.prototype.render = renderTimeBannerMain;

    function InTitleClock(options) {
        if (isRealAgent()) {
            this._config = {'showseconds' : 0, 'hourtype' : 24, 'locale': 'en', 'location': ''};
            this._renderTo = document.getElementsByTagName('title')[0];
            if(typeof options['locale'] !== tU) {
                this._config['locale'] = options['locale'];
            }
            if (typeof options['location'] !== tU) {
                this._config['location'] = String(options['location']);
            }
            this._template = (parseInt(options['hourtype'], 10) === 24 ) ? '%H:%i' : '%h:%i %ampm';
            if (this._config['location'] !== '') {
                this._template += ' ' + this._config['location'];
            }
            this._locale = TzClock.getLocale(this._config['locale']);
        }
    }
    InTitleClock.prototype.render = renderClock;

    obj.DigitalClock = DigitalClock;
    obj.TimeBanner = TimeBanner;
    obj.ConverterClock = ConverterClock;
    obj.TimeBannerMain = TimeBannerMain;
    obj.InTitleClock = InTitleClock;
})(TzClock);

;(function(){
    function toggleFullScreen() {
        document.body.classList.toggle('full-mode');
        if('undefined' !== typeof dataLayer) {
            dataLayer.push({'event': 'clock_fullscreen'});
        }
    }

    function addEvListener(node, ev_name, cb) {
        node.addEventListener ? node.addEventListener(ev_name, cb) :
            node.attachEvent && node.attachEvent("on" + ev_name, cb);
    }

    function setEventForFullScreenBtn() {
        var full_screen_btn = document.getElementsByClassName('fullscreen-ico');
        if(full_screen_btn.length > 0) {
            for(var i = 0, j = full_screen_btn.length; i < j; i++) {
                addEvListener(full_screen_btn[i], 'click', toggleFullScreen);
            }
        } else if('complete' !== document.readyState) {
            setTimeout(setEventForFullScreenBtn, 100);
        }
    }
    setEventForFullScreenBtn();
})();
